import { createExperiencePage } from "../shared/createExperiencePage";

const defaultContent = {
  meta: {
    title: "Accommodation in Lapland | Cold Experience Guesthouse",
    description:
      "Stay in our renovated Lapland schoolhouse with private apartments, sauna and hot tub just steps from the trails.",
    keywords: "lapland accommodation, lodge in lapland, cold experience stay",
    ogTitle: "Stay with Cold Experience in Lapland",
    ogDescription:
      "Comfortable apartments, local meals and spa facilities included in every package.",
    ogImage: "/og/holiday-packages.jpg",
    siteUrl: "https://coldexperience.se",
    canonicalPath: "/en/accommodation",
    jsonLd: {
      "@context": "https://schema.org",
      "@type": "LodgingBusiness",
      name: "Cold Experience Guesthouse",
      description:
        "Family-run accommodation in Råstrand, Swedish Lapland with private apartments, sauna and local dining.",
      image: "/images/Nya_bilder/IMG_4527.webp",
      address: {
        "@type": "PostalAddress",
        streetAddress: "Skolvägen 12",
        addressLocality: "Råstrand",
        addressRegion: "Lapland",
        postalCode: "930 90",
        addressCountry: "SE",
      },
      telephone: "+46 73 181 45 68",
      amenityFeature: [
        {
          "@type": "LocationFeatureSpecification",
          name: "Wood-fired sauna",
          value: true,
        },
        {
          "@type": "LocationFeatureSpecification",
          name: "Outdoor hot tub",
          value: true,
        },
        {
          "@type": "LocationFeatureSpecification",
          name: "Full-board dining",
          value: true,
        },
        {
          "@type": "LocationFeatureSpecification",
          name: "Private apartments",
          value: true,
        },
      ],
    },
  },
  media: {
    videoSrc: "/optimized_videos/coldexperience3-opt.mp4",
    poster: "/images/Nya_bilder/IMG_4527.webp",
    introVideo: "/skolan-bilder/Skolan-film-2.mp4",
    introPoster: "/images/Nya_bilder/IMG_4596 (1).webp",
    scale: 1.3,
  },
  hero: {
    title: "Stay with us in Lapland",
    description:
      "Sleep in our historic village schoolhouse converted into cosy apartments with access to sauna, hot tub and shared lounge.",
    primaryButton: {
      label: "Check Availability",
      target: "book",
    },
    secondaryButton: {
      label: "Talk to the hosts",
      target: "contact",
    },
  },
  intro: {
    heading: "Comfort after every adventure",
    paragraphs: [
      "Each apartment includes a private bedroom loft, living space and kitchenette so you can unwind exactly the way you prefer.",
      "We prepare breakfast, lunch and dinner with locally sourced ingredients and can adapt menus for any dietary needs.",
    ],
  },
  features: [
    {
      icon: "Users",
      title: "Space for families",
      description: "Two-bedroom apartments with space for up to six guests.",
    },
    {
      icon: "Heart",
      title: "Wellness area",
      description:
        "Wood-fired sauna, outdoor hot tub and relaxation lounge.",
    },
    {
      icon: "Thermometer",
      title: "Always warm",
      description:
        "Heated drying room keeps your gear ready for the next outing.",
    },
    {
      icon: "CheckCircle",
      title: "All-inclusive",
      description:
        "Full-board dining with local ingredients and homemade treats.",
    },
  ],
  sectionsHeading: "What our guesthouse offers",
  sections: [
    {
      id: "rooms",
      title: "Apartments & rooms",
      icon: "Star",
      items: [
        "Two private apartments plus cosy double rooms",
        "Loft bedrooms with quality bedding",
        "Spacious living areas with smart TV and Wi-Fi",
        "Private bathrooms with rain showers",
      ],
    },
    {
      id: "wellness",
      title: "Sauna & relaxation",
      icon: "Heart",
      items: [
        "Traditional wood-fired sauna every evening",
        "Outdoor hot tub under the night sky",
        "Massage and stretching on request",
        "Fireplace lounge with library and games",
      ],
    },
    {
      id: "dining",
      title: "Dining & gatherings",
      icon: "Coffee",
      items: [
        "Breakfast buffet with homemade bread and berries",
        "Warm lunches served during activities",
        "Three-course dinners inspired by Lapland seasons",
        "Vegan, vegetarian and allergy-friendly menus",
      ],
    },
  ],
  dayProgram: {
    title: "A day at the guesthouse",
    steps: [
      {
        icon: "Clock",
        title: "Morning",
        description:
          "Wake up to coffee aroma and breakfast buffet before heading out.",
      },
      {
        icon: "Compass",
        title: "Adventures",
        description:
          "Your guide picks you up for the day's chosen experience.",
      },
      {
        icon: "Thermometer",
        title: "Warm welcome",
        description:
          "Return to a hot sauna and outdoor tub under the stars.",
      },
      {
        icon: "Heart",
        title: "Evening",
        description:
          "Share stories over a homemade dinner and plan tomorrow.",
      },
    ],
  },
  closing: {
    title: "Make our home yours",
    description:
      "Tell us how you like to travel and we will tailor a stay that balances adventure and comfort.",
    primaryButton: {
      label: "Book Your Stay",
      target: "book",
    },
    secondaryButton: {
      label: "Ask the hosts",
      target: "contact",
    },
    showStarRating: true,
    ratingText: "Guests rate the guesthouse 4.9/5",
  },
  settings: {
    showFooter: false,
  },
};

export default createExperiencePage({
  translationKey: "lodging",
  defaultContent,
  routeKey: "accommodation",
});
